import { FunctionalComponent, h } from '@stencil/core';
import { RiskRatingImages } from '../../_interfaces/fund-card/risk-rating-images';

interface RiskRatingImageProps {
	rating: string;
	images: RiskRatingImages;
}

/**
 * Show the risk rating image, with another image overlaid on top that highlights one of the numbers as per the rating.
 *
 * @param rating   Numeric string that comes from the server. Can also be non-numeric eg. "-".
 * @param images	 Object containing paths to the two images.
 */
export const RiskRatingImage: FunctionalComponent<RiskRatingImageProps> = ({
	rating,
	images,
}) => {
	const { riskDisk, riskScale } = images;
	const riskRatingInteger = parseInt(rating);

	/**
	 * If the rating is returned by the server as eg. "-" then it's not a number so it won't translate into displaying
	 * in the risk scale image as a highlighted number. The fallback for this is to still show the main image but without
	 * the overlaid image; therefore no number will be highlighted. This is the safest thing to do for compliance.
	 */
	const isRatingValid = !isNaN(riskRatingInteger);

	return (
		<div class="ds-risk-rating-image-container">
			<img src={riskDisk} alt="Risk Rating" />
			{!isRatingValid || (
				<div class={`ds-scale ds-scale-${riskRatingInteger}`}>
					<img src={riskScale} alt={rating} />
				</div>
			)}
		</div>
	);
};
